
export default {
    props: {
        listTitle: String,
        list: Array,
        text: String
    }
}
